import React from "react";
import { SectionHeader } from "./section-header.tsx";

export const VideoSection: React.FC = () => {
  return (
    <section className="flex flex-col items-center mx-auto max-w-[700px] gap-5 md:gap-9">
      <SectionHeader
        heading="Why choose ESPC for your home valuation?"
        headingAs="h2"
        subheading="As Edinburgh and East Central Scotland’s leading property experts, we provide accurate, reliable property valuations based on local market knowledge."
      />

      <div className={"w-full aspect-video shadow-lg relative max-w-[500px] lg:max-w-[700px]"}>
        <iframe
          title="Video: Get a property valuation with an ESPC solicitor estate agent"
          src="https://www.youtube-nocookie.com/embed/z2V_k30IPD0?si=KsrO21GhS3_z6H7l"
          style={{ width: "100%", height: "100%", position: "absolute", top: 0, left: 0 }}
          allow="autoplay; fullscreen"
          referrerPolicy="strict-origin-when-cross-origin"
          allowFullScreen
        />
      </div>
    </section>
  );
};
